(function () {
  function fixStuckLazyImages() {
    document.querySelectorAll('img.lazyload').forEach(function (img) {
      var srcset = img.getAttribute('data-srcset');
      if (!srcset) return;
      img.srcset = srcset;
      if (!img.sizes || img.sizes === 'auto') {
        img.sizes = img.getBoundingClientRect().width + 'px';
      }
      img.classList.remove('lazyload');
      img.classList.add('lazyloaded');
    });
  }

  // Run on load, and re-run whenever new product cards get added
  // (search results, filtering, infinite scroll, etc.)
  fixStuckLazyImages();
  const observer = new MutationObserver(function () {
    fixStuckLazyImages();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();